module.exports = __webpack_public_path__ + "static/img/2.eafafc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/eng/2.png
// module id = F2wm
// module chunks = 0